/* eslint-disable */
import React, { useEffect, useState,useRef } from 'react';
// services
import applicationSvc from "services/applicationSvc";

// library
import { DateRangePickerComponent,PresetsDirective, PresetDirective  } from '@syncfusion/ej2-react-calendars';
import moment from "moment";
import _ from 'lodash';
import { useHistory, useLocation  } from 'react-router-dom';
import { useParams } from "react-router-dom";
import styled from 'styled-components';
import { Alert,AlertType } from "utils/Alert";

// component
import Svg from "_assets/svg";
import Divider from 'components/Divider';
import H1 from 'components/H1';
import H4 from 'components/H4';
import H3 from 'components/H3';
import H5 from 'components/H5';
import PageButton from 'components/PageButton.js';
import Dropdown from 'components/Dropdown';
import RefreshButton from './RefreshButton';
import Wrapper from './Wrapper';
import Table from './TableData';
import Close from "_assets/images/close.png";
import Input from './Input';

// helpers
import { formatDate, today, yesterday, monthStart, weekEnd } from 'utils/dateFormat';

// import TableMobile from './TableMobile';

const Div = styled.div`
  @media only screen and (max-width: 1024px) {
    display: none !important;
  }
`;
const ButtonExport = styled.button`
  /* Frame 57 */

  /* Auto Layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 15px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafd 100%);
  border: 1px solid #bbc1c8;
  box-sizing: border-box;
  border-radius: 8px;
`;


const Icon = styled.img``;

const DetailApplicationPage = (props) => {
  const { location } = props;
  const locationId = useLocation();

  const dataApp = locationId?.state?.data;

  const history = useHistory();
  const { id } = useParams();
  const [isDataUser, setDataUser] = useState([])
  const [isLoading, setLoading] = useState(false);
  const [isLoadingDownload, setLoadingDownload] = useState(false)
  const [selectedSortByStatus, setSelectedSortByStatus] = useState(0);
  const [selectedSortByChannel, setSelectedSortByChannel] = useState(0);
  const [page, setPage] = useState(1);
  const [isLocation] = useState(locationId?.state?.dataPayload);

  const [isTextDate, setTextDate] = useState([
    isLocation?.startDate ? 
    isLocation?.startDate :
    moment(new Date()).format("YYYY-MM-DD"),
    isLocation?.endDate ? 
    isLocation?.endDate :
    moment(new Date()).format("YYYY-MM-DD")])
    
  const [isDataPage, setDataPage] = useState();
  const [isPagination, setPagination] = useState({
    writeStartFrom: 0,
    writeStartTo: 0,
    totalWrites: 0
  });
  const [typeSearch, setTypeSearch] = useState('');
  const [isFilterData, setFilterData] = useState('');
  const [rangeDate, setRangeDate] = useState([new Date(), new Date()]);

  let startDateData = isLocation?.startDate ? 
  isLocation?.startDate : 
  moment(rangeDate[0] || rangeDate?.start).format("YYYY-MM-DD");
  let endDateData = isLocation?.endDate ? 
  isLocation?.endDate :  
  moment(rangeDate[1] || rangeDate?.end).format("YYYY-MM-DD");
  const [isShowListSearch, setShowListSearch] = useState(false);
  const [isListSearch,setListSearch] = useState([
      { name: 'Message ID', key: 'msgid', value: '' },
      { name: 'Number', key: 'phone_number', value: '' },
      { name: 'Email', key: 'email', value: '' }
  ])
  const [isSelectedSearch,setSelectedSearch] = useState(null)
  const SortByChannel = [
    {
      name: 'Whatsapp',
      value: 'whatsapp',
      onClick: () => {
        setSelectedSortByChannel(0)
      },
    },
    {
      name: 'SMS',
      value: 'sms',
      onClick: () => {
        setSelectedSortByChannel(1)
      },
    },
    {
      name: 'Email',
      value: 'email',
      onClick: () => {
        setSelectedSortByChannel(2)
      },
    },
    {
      name: 'Voice',
      value: 'call',
      onClick: () => {
        setSelectedSortByChannel(3)
      },
    },
    {
      name: 'Voice OTP',
      value: 'voice_otp',
      onClick: () => {
        setSelectedSortByChannel(4)
      },
    },
    {
      name: 'SMS OTP',
      value: 'sms_otp',
      onClick: () => {
        setSelectedSortByChannel(5)
      },
    },
  ];

  const SortByStatusWa = [
    {
      name: 'All',
      value: '',
      onClick: () => setSelectedSortByStatus(0),
    },
    {
      name: 'Read',
      value: 'read',
      onClick: () => setSelectedSortByStatus(1),
    },
    {
      name: 'Rejected',
      value: 'rejected',
      onClick: () => setSelectedSortByStatus(2),
    },
    {
      name: 'Failed',
      value: 'failed',
      onClick: () => setSelectedSortByStatus(3),
    },
    {
      name: 'Submitted',
      value: 'submitted',
      onClick: () => setSelectedSortByStatus(4),
    },
    {
      name: 'In Queue',
      value: 'in_queue',
      onClick: () => setSelectedSortByStatus(5),
    },
    {
      name: 'Delivered',
      value: 'delivered',
      onClick: () => setSelectedSortByStatus(6),
    }
  ];
  const SortByStatusSms = [
    {
      name: 'All',
      value: '',
      onClick: () => setSelectedSortByStatus(0),
    },
    {
      name: 'Submitted',
      value: 'submitted',
      onClick: () => setSelectedSortByStatus(1),
    },
    {
      name: 'In Queue',
      value: 'in_queue',
      onClick: () => setSelectedSortByStatus(2),
    },
    {
      name: 'Sent',
      value: 'sent',
      onClick: () => setSelectedSortByStatus(3),
    },
    {
      name: 'Delivered',
      value: 'delivered',
      onClick: () => setSelectedSortByStatus(4),
    }
  ];
  const SortByStatusSmsOTP = [
    {
      name: 'All',
      value: '',
      onClick: () => setSelectedSortByStatus(0),
    },
    {
      name: 'Failed',
      value: 'failed',
      onClick: () => setSelectedSortByStatus(1),
    },
    {
      name: 'Submitted',
      value: 'submitted',
      onClick: () => setSelectedSortByStatus(2),
    },
    {
      name: 'In Queue',
      value: 'in_queue',
      onClick: () => setSelectedSortByStatus(3),
    },
    {
      name: 'Sent',
      value: 'sent',
      onClick: () => setSelectedSortByStatus(4),
    },
    {
      name: 'Delivered',
      value: 'delivered',
      onClick: () => setSelectedSortByStatus(5),
    },
    {
      name: 'Undelivered',
      value: 'undelivered',
      onClick: () => setSelectedSortByStatus(6),
    }
  ];
  const SortByStatusEmail = [
    {
      name: 'All',
      value: '',
      onClick: () => setSelectedSortByStatus(0),
    },
    {
      name: 'Opened',
      value: 'opened',
      onClick: () => setSelectedSortByStatus(1),
    },
    {
      name: 'Clicked',
      value: 'clicked',
      onClick: () => setSelectedSortByStatus(2),
    },
    {
      name: 'Failed',
      value: 'failed',
      onClick: () => setSelectedSortByStatus(3),
    },
    {
      name: 'Submitted',
      value: 'submitted',
      onClick: () => setSelectedSortByStatus(4),
    },
    {
      name: 'In Queue',
      value: 'in_queue',
      onClick: () => setSelectedSortByStatus(5),
    },
    {
      name: 'Unsubscribe',
      value: 'unsubscribe',
      onClick: () => setSelectedSortByStatus(6),
    },
    {
      name: 'Delivered',
      value: 'delivered',
      onClick: () => setSelectedSortByStatus(7),
    },
  ];
  const SortByStatusCall = [
    {
      name: 'All',
      value: '',
      onClick: () => setSelectedSortByStatus(0),
    },
    {
      name: 'Failed',
      value: 'failed',
      onClick: () => setSelectedSortByStatus(1),
    },
    {
      name: 'In Queue',
      value: 'in_queue',
      onClick: () => setSelectedSortByStatus(2),
    },
    {
      name: 'Rna',
      value: 'rna',
      onClick: () => setSelectedSortByStatus(3),
    },
    {
      name: 'Answered',
      value: 'answered',
      onClick: () => setSelectedSortByStatus(4),
    }
  ];
  const SortByStatusCallOTP = [
    {
      name: 'All',
      value: '',
      onClick: () => setSelectedSortByStatus(0),
    },
    {
      name: 'Failed',
      value: 'failed',
      onClick: () => setSelectedSortByStatus(1),
    },
   
    {
      name: 'In Queue',
      value: 'in_queue',
      onClick: () => setSelectedSortByStatus(2),
    },
    {
      name: 'Submitted',
      value: 'submitted',
      onClick: () => setSelectedSortByStatus(3),
    },
    {
      name: 'Success',
      value: 'success',
      onClick: () => setSelectedSortByStatus(4),
    },
  ];

  const handleChangeSortByStatus = (status) => {
    setFilterData(status.value)

    filteredChannelby({ pageValue: 1, searching: typeSearch !== '' ? typeSearch : null, filterData: status.value, startDateFilter: startDateData, endDateFilter: endDateData }, SortByChannel[selectedSortByChannel].value)
  };

  const handleChangeSortByChannel = (ch) => {
    console.log('chh',ch)
    filteredChannelby({ pageValue: 1, searching: null, filterData: '', startDateFilter: startDateData, endDateFilter: endDateData }, ch.value);
    setSelectedSortByStatus(0)
  }

  // const resetPagination = () => {
  //   setPage(1);
  //   setStartFrom(1);
  // };



  const handleTypeSearch = (event) => {
    setTypeSearch(event.target.value)
    delayedQuery(event.target.value);
    // setSelectedSortByStatus(0)
  };

  const delayedQuery = _.debounce((value) => {
    if (value) {
      filteredChannelby({ pageValue: 1, searching: value, filterData: isFilterData !== '' ? isFilterData : '', startDateFilter: startDateData, endDateFilter: endDateData }, SortByChannel[selectedSortByChannel].value)
    } else {
      filteredChannelby({ pageValue: 1, searching: null, filterData: isFilterData !== '' ? isFilterData : '', startDateFilter: startDateData, endDateFilter: endDateData }, SortByChannel[selectedSortByChannel].value)
    }
  }, 2000);

  const handleRefresh = () => {
    filteredChannelby({ pageValue: 1, searching: null, filterData: '', startDateFilter: startDateData, endDateFilter: endDateData }, SortByChannel[selectedSortByChannel].value)
    resetAllFilter();
  };

  const resetAllFilter = () => {
    setSelectedSortByStatus(0);
    setTypeSearch('');
  };

  const handlePrevPage = () => {
    if (page - 1 >= 1) {
      filteredChannelby({ pageValue: page - 1, searching: typeSearch !== '' ? typeSearch : null, filterData: isFilterData !== '' ? isFilterData : '', startDateFilter: startDateData, endDateFilter: endDateData }, SortByChannel[selectedSortByChannel].value)
    }
  };

  const handleNextPage = () => {
    if (page + 1 <= isDataPage?.pages) {
      filteredChannelby({ pageValue: page + 1, searching: typeSearch !== '' ? typeSearch : null, filterData: isFilterData !== '' ? isFilterData : '', startDateFilter: startDateData, endDateFilter: endDateData }, SortByChannel[selectedSortByChannel].value)
    }
  };


  useEffect(() => {
    filteredChannelby({ pageValue: 1, searching: null, filterData: '', startDateFilter: startDateData, endDateFilter: endDateData }, isLocation?.channel ? isLocation?.channel : SortByChannel[selectedSortByChannel].value)
   
    switch(isLocation?.channel){
      case 'whatsapp':
        setSelectedSortByChannel(0)
        break;

      case 'sms':
        setSelectedSortByChannel(1)
        break;

      case 'email':
        setSelectedSortByChannel(2)
        break;

      case 'call':
        setSelectedSortByChannel(3)
        break;

      case 'voice_otp':
        setSelectedSortByChannel(4)
        break;

      case 'sms_otp':
        setSelectedSortByChannel(5)
        break;

    default:
      break
    }
  }, [])

  const [isValueChannel, setValueChannel] = useState('');

  const filteredChannelby = (d, ch) => {
    setValueChannel(ch)

    switch (ch) {
      case 'whatsapp':
        getDataUserWA(d)
        break;

      case 'sms':
        getDataUserSMS(d)
        break;

      case 'sms_otp':
        getDataUserSMSOTP(d)
        break;

      case 'email':
        getDataUserEmail(d)
        break;

      case 'call':
        getDataUserCall(d)
        break;

      case 'voice_otp':
        getDataUserCallOtp(d)
        break;

      default:
        break;
    }
  };

  const getDataUserSMSOTP = async (valueParams = '') => {
    setDataUser([])
    const { searching, pageValue = 1, filterData, startDateFilter, endDateFilter } = valueParams;
    let dataSearch = isSelectedSearch
    if(valueParams.searching){
      dataSearch.value = valueParams?.searching
    }
    setLoading(true)
    const dataUser = {
      search:searching === '' || searching === null ? {} : dataSearch,
      startDate: startDateFilter,
      endDate: endDateFilter,
      showType: filterData === '' ? 'all' : filterData,
      // sortBy: 'created_at',
      limit: 10,
      page: pageValue,
      application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id
    }
    const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
    await applicationSvc.generateSmsOTP(appId,dataUser)
      .then(response => {
        setDataUser(response.data.data)
        setPage(response.data.page)
        setDataPage(response.data)
        setPagination({
          writeStartFrom: (response.data.limit * response.data.page) - (response.data.limit - 1),
          writeStartTo: response.data.total <= (response.data.limit * response.data.page) ? response.data.total : (response.data.limit * response.data.page),
          totalWrites: response.data.total
        })

      })
      .catch(error => {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error?.response?.data?.errors[0]?.message
        )
      })
    setLoading(false)
  }
  const getDataUserSMS = async (valueParams = '') => {
    setDataUser([])
    const { searching, pageValue = 1, filterData, startDateFilter, endDateFilter } = valueParams;
    let dataSearch = isSelectedSearch
    if(valueParams.searching){
      dataSearch.value = valueParams?.searching
    }
    setLoading(true)
    const dataUser = {
      search:searching === '' || searching === null ? {} : dataSearch,
      startDate: startDateFilter,
      endDate: endDateFilter,
      showType: filterData === '' ? 'all' : filterData,
      // sortBy: 'created_at',
      limit: 10,
      page: pageValue,
      application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id
    }
    const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
    await applicationSvc.generateSmsRecord(appId,dataUser)
      .then(response => {
        setDataUser(response.data.data)
        setPage(response.data.page)
        setDataPage(response.data)
        setPagination({
          writeStartFrom: (response.data.limit * response.data.page) - (response.data.limit - 1),
          writeStartTo: response.data.total <= (response.data.limit * response.data.page) ? response.data.total : (response.data.limit * response.data.page),
          totalWrites: response.data.total
        })

      })
      .catch(error => {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error?.response?.data?.errors[0]?.message
        )
      })
    setLoading(false)
  }

  const getDataUserWA = async (valueParams = '') => {
    setDataUser([])
    const { searching, pageValue = 1, filterData, startDateFilter, endDateFilter } = valueParams;
    let dataSearch = isSelectedSearch
    if(valueParams.searching){
      dataSearch.value = valueParams?.searching
    }
    setLoading(true)
    const dataUser = {
      application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id,
      startDate: startDateFilter,
      endDate: endDateFilter,
      page: pageValue,
      limit: 10,
      showType: filterData,
      search:searching === '' || searching === null ? {} : dataSearch,
      // sortBy: "created_at"
    }
    const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
    await applicationSvc.generateSWaRecord(appId,dataUser)
      .then(response => {
        setDataUser(response.data.data)
        setPage(response.data.page)
        setDataPage(response.data)
        setPagination({
          writeStartFrom: (response.data.limit * response.data.page) - (response.data.limit - 1),
          writeStartTo: response.data.total <= (response.data.limit * response.data.page) ? response.data.total : (response.data.limit * response.data.page),
          totalWrites: response.data.total
        })
      })
      .catch(error => {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error?.response?.data?.errors[0]?.message
        )
      })
    setLoading(false)
  }

  const getDataUserEmail = async (valueParams = '') => {
    setDataUser([])
    const { searching, pageValue = 1, filterData, startDateFilter, endDateFilter } = valueParams
    let dataSearch = isSelectedSearch
    if(valueParams.searching){
      dataSearch.value = valueParams?.searching
    }
    setLoading(true)
    const dataUser = {
      application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id,
      startDate: startDateFilter,
      endDate: endDateFilter,
      page: pageValue,
      limit: 10,
      showType: filterData,
      search:searching === '' || searching === null ? {} : dataSearch,
      // sortBy: "created_at"
    }
    const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
    await applicationSvc.generateEmailRecord(appId,dataUser)
      .then(response => {
        // console.log('result', response)
        setDataUser(response.data.data)
        setPage(response.data.page)
        setDataPage(response.data)
        setPagination({
          writeStartFrom: (response.data.limit * response.data.page) - (response.data.limit - 1),
          writeStartTo: response.data.total <= (response.data.limit * response.data.page) ? (response.data.limit * response.data.page) - (response.data.limit * response.data.page - response.data.total) : (response.data.limit * response.data.page),
          totalWrites: response.data.total
        })
      })
      .catch(error => {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error?.response?.data?.errors[0]?.message
        )
      })
    setLoading(false)
  }

  const getDataUserCall = async (valueParams = '') => {
    setDataUser([])
    const { searching, pageValue = 1, filterData, startDateFilter, endDateFilter } = valueParams
    let dataSearch = isSelectedSearch
    if(valueParams.searching){
      dataSearch.value = valueParams?.searching
    }
    setLoading(true)
    const dataUser = {
      application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id,
      startDate: startDateFilter,
      endDate: endDateFilter,
      page: pageValue,
      limit: 10,
      showType: filterData,
      search:searching === '' || searching === null ? {} : dataSearch,
      // sortBy: "created_at"
    }
    const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
    await applicationSvc.generateCallRecord(appId,dataUser)
      .then(response => {
        // console.log('result', response)
        setDataUser(response.data.data)
        setPage(response.data.page)
        setDataPage(response.data)
        setPagination({
          writeStartFrom: (response.data.limit * response.data.page) - (response.data.limit - 1),
          writeStartTo: response.data.total <= (response.data.limit * response.data.page) ? response.data.total : (response.data.limit * response.data.page),
          totalWrites: response.data.total
        })
      })
      .catch(error => {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error?.response?.data?.errors[0]?.message
        )
      })
    setLoading(false)
  }

  const getDataUserCallOtp = async (valueParams = '') => {
    setDataUser([])
    const { searching, pageValue = 1, filterData, startDateFilter, endDateFilter } = valueParams
    let dataSearch = isSelectedSearch
    if(valueParams.searching){
      dataSearch.value = valueParams?.searching
    }
    setLoading(true)
    const dataUser = {
      application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id,
      startDate: startDateFilter,
      endDate: endDateFilter,
      page: pageValue,
      limit: 10,
      showType: filterData,
      search:searching === '' || searching === null ? {} : dataSearch,
      // sortBy: "created_at"
    }
    const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
    await applicationSvc.generateCallOtpRecord(appId,dataUser)
      .then(response => {
        // console.log('result', response)
        setDataUser(response.data.data)
        setPage(response.data.page)
        setDataPage(response.data)
        setPagination({
          writeStartFrom: (response.data.limit * response.data.page) - (response.data.limit - 1),
          writeStartTo: response.data.total <= (response.data.limit * response.data.page) ? response.data.total : (response.data.limit * response.data.page),
          totalWrites: response.data.total
        })
      })
      .catch(error => {
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          error?.response?.data?.errors[0]?.message
        )
      })
    setLoading(false)
  }

  const handleOnchangeDate = (date) =>{

    if(date?.value !== null && date?.value !== undefined) {
      const startDateTemp = moment(date?.value[0]).format("YYYY-MM-DD");
      const endDateTemp = moment(date?.value[1]).format("YYYY-MM-DD");

      filteredChannelby({ pageValue: 1, searching: typeSearch, filterData: isFilterData !== '' ? isFilterData : '', startDateFilter: startDateTemp, endDateFilter: endDateTemp }, SortByChannel[selectedSortByChannel].value)
      setRangeDate(date?.value);
      setTextDate(formatDate(new Date(date.value[0])) + ' - ' + formatDate(new Date(date.value[1])))
    }
  }

  const dataUser1 = {
    application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id,
    startDate: startDateData,
    endDate: endDateData,
    page: 1,
    limit: 10,
    showType: isFilterData !== '' ? isFilterData : 'all',
    search: 'a',
    sortBy: "created_at"
  }
  const dataUser2 = {
    application_id: dataApp?._id ? dataApp?._id : isLocation?.application_id,
    startDate: startDateData,
    endDate: endDateData,
    // page: 1,
    // limit: 10,
    showType: isFilterData !== '' ? isFilterData : '',
    search: typeSearch,
    // sortBy: "created_at"
  }

  async function downloadReport() {
    if (isValueChannel === "sms") {
      setLoadingDownload(true)
      const params = new URLSearchParams(dataUser1);
      const appId = dataApp?._id ? dataApp?._id : isLocation?.application_id;
      applicationSvc.generateSMSDownload(appId,params)
        .then(res => {
          // console.log('first tohel',res);
          if (res?.data?.message !== 'Data Is Empty') {
            const link = document.createElement("a");
            link.target = "_blank";
            // link.download = "report_sms";
            link.download = `SMS Report-createdAt-${moment(new Date()).format('DD-MM-YYYY')}`;
            setLoadingDownload(true);
            applicationSvc.monitoringSMSDownloadBuffer(appId,params)
              .then((result) => {
                link.href = URL.createObjectURL(
                  new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                );
                link.click();
                link.remove();
                setLoadingDownload(false);
                Alert.showStatus(
                  AlertType.SUCCESS,
                  'Success!',
                  'Report results have been downloaded successfully'
                )
              }).catch(() => {
                setLoadingDownload(false);
              })
          } else {
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            );
            setLoadingDownload(false);
          }
          if(res.data.message === "Data Is Empty"){
            setLoadingDownload(false);
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
          }
        })
        .catch(()=>{
          setLoadingDownload(false)
            Alert.showStatus(
              AlertType.ERROR,
              'Error!',
              'Something went wrong or Data Is Empty'
            )
        })
    }
  }

  useEffect(() => {
    setSelectedSearch({
      name: 'Message ID',
      key: 'msgid',
      value: ''
    })
    document.body.style.overflow = "scroll";
  }, []);

  useEffect(() => {
    setSelectedSearch({
      name: 'Message ID',
      key: 'msgid',
      value: ''
    })
    document.body.style.overflow = "scroll";
  }, []);

  useEffect(() => {
  if(isValueChannel === 'email'){
    setListSearch([
      { name: 'Message ID', key: 'msgid', value: '' },
      { name: 'Email', key: 'email', value: '' }
    ])
  }else{
    setListSearch([
      { name: 'Message ID', key: 'msgid', value: '' },
      { name: 'Number', key: 'phone_number', value: '' }
    ])
  }
  setTypeSearch('')
  }, [isValueChannel]);

  let dateRange = useRef()
  function handleClickDate(value){
    dateRange?.current?.show()
  }

  function resetDate(){
    setRangeDate("")
    startDateData = "";
    endDateData = "";
    setTextDate('Select date...');
  }

  function redirectTo(){
    history.push({
      pathname: "/generate-report",
      state: { showPopUp: true },
    });
  }

  function handleClickSearch(){
    setShowListSearch(!isShowListSearch)
  }

  function chooseSearchType(item){
    setSelectedSearch(item)
    setShowListSearch(false)
  }

  return (
    <Wrapper className="d-flex flex-column container-fluid no-pad" style={{height:'100%'}}>
      <div className="d-flex flex-row align-items-center justify-content-between" style={{ paddingTop: 16 }}>
        <div className="d-flex flex-column">
          <H3 className="margin-bottom-10">Monitoring</H3>
          <H1 className="margin-bottom-10">{dataApp?.applicationName}</H1>
          <H4 className="margin-bottom-25">{`ApplicationID: ${id}`}</H4>
        </div>
      
        {/* <ButtonExport onClick={downloadReport}>
          <Icon className="margin-right-12" src={Svg.download.default} />
          <H5 className="fw-bold">
            Export
          </H5>
        </ButtonExport> */}
      </div>
      <div className="d-flex flex-row justify-content-between align-items-center margin-bottom-20">
        <div className="d-flex flex-row align-items-center">
          <Dropdown
            title="Channel:"
            data={SortByChannel}
            selected={selectedSortByChannel}
            onChange={(val) => handleChangeSortByChannel(val)}
            className="margin-right-15"
          />
          {isValueChannel === "whatsapp" && (
            <Dropdown
              title="Filter:"
              data={SortByStatusWa}
              selected={selectedSortByStatus}
              onChange={(val) => handleChangeSortByStatus(val)}
              className="margin-right-15"
            />
          )}
          {isValueChannel === "sms" && (
            <Dropdown
              title="Filter:"
              data={SortByStatusSms}
              selected={selectedSortByStatus}
              onChange={(val) => handleChangeSortByStatus(val)}
              className="margin-right-15"
            />
          )}
          {isValueChannel === "sms_otp" && (
            <Dropdown
              title="Filter:"
              data={SortByStatusSmsOTP}
              selected={selectedSortByStatus}
              onChange={(val) => handleChangeSortByStatus(val)}
              className="margin-right-15"
            />
          )}
          {isValueChannel === "email" && (
            <Dropdown
              title="Filter:"
              data={SortByStatusEmail}
              selected={selectedSortByStatus}
              onChange={(val) => handleChangeSortByStatus(val)}
              className="margin-right-15"
            />
          )}
          {isValueChannel === "call" && (
            <Dropdown
              title="Filter:"
              data={SortByStatusCall}
              selected={selectedSortByStatus}
              onChange={(val) => handleChangeSortByStatus(val)}
              className="margin-right-15"
            />
          )}
          {isValueChannel === "voice_otp" && (
            <Dropdown
              title="Filter:"
              data={SortByStatusCallOTP}
              selected={selectedSortByStatus}
              onChange={(val) => handleChangeSortByStatus(val)}
              className="margin-right-15"
            />
          )}

          <div className='custom-ej2date datepicker-control-section margin-right-15'>
             <DateRangePickerComponent
                delayUpdate={true}
                ref={(scope)=>{dateRange.current = scope}}
                enableRtl={true}
                className='custom-ej2date'   
                change={handleOnchangeDate}
                minDays={1} 
                maxDays={31}
                value={isTextDate}
                placeholder='Choose date'>
                  <PresetsDirective>
                    <PresetDirective label="Today" start={today} end={today}></PresetDirective>
                    <PresetDirective label="Yesterday" start={yesterday} end={today}></PresetDirective>
                    <PresetDirective label="Last 7 Days" start={weekEnd} end={today}></PresetDirective>
                    <PresetDirective label="Last 30 Days" start={monthStart} end={today}></PresetDirective>
                  </PresetsDirective>
              </DateRangePickerComponent>
            <div className="form-control wrap-date-ejs mb-2 date_detail_page" style={{marginTop:'-33px',position:'relative'}}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.25 3H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3H6.75V2.25C6.75 2.05109 6.67098 1.86032 6.53033 1.71967C6.38968 1.57902 6.19891 1.5 6 1.5C5.80109 1.5 5.61032 1.57902 5.46967 1.71967C5.32902 1.86032 5.25 2.05109 5.25 2.25V3H3.75C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V5.25C16.5 4.65326 16.2629 4.08097 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM15 14.25C15 14.4489 14.921 14.6397 14.7803 14.7803C14.6397 14.921 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.921 3.21967 14.7803C3.07902 14.6397 3 14.4489 3 14.25V9H15V14.25ZM15 7.5H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H5.25V5.25C5.25 5.44891 5.32902 5.63968 5.46967 5.78033C5.61032 5.92098 5.80109 6 6 6C6.19891 6 6.38968 5.92098 6.53033 5.78033C6.67098 5.63968 6.75 5.44891 6.75 5.25V4.5H11.25V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V4.5H14.25C14.4489 4.5 14.6397 4.57902 14.7803 4.71967C14.921 4.86032 15 5.05109 15 5.25V7.5Z" fill="#42526E"/>
              </svg>
              <input
              style={{width:'100%',cursor:'pointer'}} 
                type="text" 
                className='w-full input-time-custom cursor-pointer ms-1'
                onClick={handleClickDate}
                value={isTextDate}
                required="required"
                placeholder="placetext"/>
                {
                  isTextDate !== 'Select date...' &&
                  <img className='ic-reset pinkic-hover' onClick={resetDate} src={Close}></img>
                }
            </div>
          </div>
         
          <ButtonExport onClick={redirectTo} className='mb-2'>
          <Icon className="margin-right-12" src={Svg.download.default} />
          <H5 className="fw-bold">
            Export
          </H5>
          </ButtonExport>
        </div>
        <Div className="mb-2">
        <div className='wrap_search'>
          <div className='selected'>
            <span>{isSelectedSearch?.name}</span>
            <Icon onClick={handleClickSearch} src={Svg.chevron_right.default} className={`ms-2 ${isShowListSearch ? 'rotate_180' : 'rotate_0'}`}/>
          </div>
          {isShowListSearch &&
          <div className='dropdown' >
            <div className='list_search'>
              {isListSearch.map((item, idx) =>{
                return <span onClick={()=>chooseSearchType(item)} key={idx}>{item.name}</span>
              })}
            </div>
          </div>
          }
          <div className='input_search d-flex align-items-center'>
            <Input placeholder={`Search by ${isSelectedSearch?.name} ...`} value={typeSearch} onChange={handleTypeSearch} />
            <Icon src={Svg.search.default} alt="search" />
          </div>
        </div>
        </Div>
      </div>
      <Divider className="margin-bottom-15" />
      <div className="d-flex flex-row justify-content-between align-items-center margin-bottom-15">
        <div className="d-flex flex-row align-items-center">
          {typeSearch ? (
            <H5>{`Search Result: ${typeSearch}`}</H5>
          ) : (
            <>
              <H5 className="margin-right-10">List of Transaction</H5>
              <RefreshButton loading={isLoading} onClick={handleRefresh} />
            </>
          )}
        </div>
        <div className="d-flex flex-row align-items-center">
          <H5
            className="margin-right-15"
            font="Inter"
            color="#26292D"
          >
            {`${isPagination.writeStartFrom} - ${isPagination.writeStartTo} of ${isPagination.totalWrites}`}
          </H5>
          <PageButton
            disabledLeft={page === 1}
            disabledRight={page === setDataPage?.pages}
            onPrevClick={handlePrevPage}
            onNextClick={handleNextPage}
          />
        </div>
      </div>
      <Table loading={isLoading} data={isDataUser} services={isDataPage} valueChannel={isValueChannel} />
      {/* <TableMobile data={titleState?.data} loading={titleState.loading} services={channelState?.data} /> */}
    </Wrapper>
  );
};

export default DetailApplicationPage;
